// Lightweight logger that only emits in development, keeping production
// console output clean. Use instead of raw console.error for non-fatal errors.
export function logError(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
